import { makeScript } from './makeScript';

import type { YandexMetricaProperties } from '../YandexMetricaManager.types';

export const yandexMetrica = (arguments_: YandexMetricaProperties) => {
  const snippet = makeScript(arguments_);

  const script = () => {
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = snippet;
    return scriptElement;
  };

  return {
    script,
  };
};
